import React, {useEffect, useState} from "react";
import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js";
import _ from "lodash";
import config from "../config";
import "../styles/billing.css";
import Home from "../assets/SVG/buttons/Home-button-big.svg";
import {useDispatch, useSelector} from "react-redux";
import {
  createStripeCustomer,
  createStripeSubscription,
  getAllStripeTransactions,
  getCustomerByUid,
  getPricePlan,
  getStripeProduct,
  updateStripeSubscription,
  getSubscriptionByUid,
  getProductsAndPrices,
  getUserStatus,
  cancelSubscription,
  getSubscriptionsByUid,
  updateSubscriptionAutoRenew,
} from "../api";
import Profile from "../assets/SVG/icons/Avatar.svg";
import Logout from "../assets/SVG/buttons/logout.svg";
import * as action from "../actions";
import axios from "axios";
import moment from "moment-timezone";
import "../styles/plans.css";
import ConfirmModal from "../components/ConfirmModal";
import Product from "../components/Product";
import InfoModal from "../components/InfoModal";
import {Switch} from 'antd';
import useToastify from "../hooks/useToastify";
import useCalendar from "../hooks/useCalendar";
import CheckoutForm from "../components/CheckoutForm";
import {useHistory} from "react-router-dom";

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(config.stripe.pub_key);


const ActiveSubscription = ({activeProductAndPlan}) => {
  const {product, pricePlan, currentPeriodStart, currentPeriodEnd} = activeProductAndPlan;
  return (
    <div className="active-subscription-container">
      <div className="active-subscription-product-name">
        <div className="subscription-product-name">{product?.name}</div>
        <div>
          Billed every {pricePlan?.interval_count} {pricePlan?.interval}
        </div>
      </div>
      <div className="active-sub-period">Plan Started: {currentPeriodStart}</div>
      <div className="active-sub-period">Plan End: {currentPeriodEnd}</div>
    </div>
  );
};

const Plans = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {notifySuccess, notifyError} = useToastify();
  const {calendarData, weekFrom, weekTo, monthFrom, monthTo} = useCalendar();
  const user = useSelector((state) => state.user);
  const subscriptionFromRedux = useSelector((state) => state.subscription);
  const subscriptionsFromRedux = useSelector((state) => state.subscriptions);
  const [subscription, setSubscription] = useState();
  const [subscriptions, setSubscriptions] = useState();
  const [covidSubscription, setCovidSubscription] = useState();
  const [cardioSubscription, setCardioSubscription] = useState();

  const [clientSecret, setClientSecret] = useState();
  const [covidClientSecret, setCovidClientSecret] = useState();
  const [cardioClientSecret, setCardioClientSecret] = useState();

  const [planPrice, setPlanPrice] = useState();
  const [stripeCustomer, setStripeCustomer] = useState();
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [isLoading, setIsloading] = useState(true);
  const [planDuration, setPlanDuration] = useState("month");
  const [planDurationInterval, setPlanDurationInterval] = useState(3);
  const [subscribedPlan, setSubscribedPlan] = useState();
  const [currentPricePlan, setCurrentPricePlan] = useState();
  const [currentProduct, setCurrentProduct] = useState();
  const [showConfirm, setShowConfirm] = useState(false);
  const [products, setProducts] = useState([]);
  const [showInfo, setShowInfo] = useState(false);
  const [showOneTimeProductWarning, setShowOneTimeProductWarning] = useState(false);
  const [showMonthlyProductRenewWarning, setShowMonthlyProductRenewWarning] = useState(false);
  const [showMonthlyProductRenewWarningCovid, setShowMonthlyProductRenewWarningCovid] = useState(false);
  const [affiliateAccount, setAffiliateAccount] = useState();
  const [productForUpdateSubs, setProductForUpdateSubs] = useState();
  const [selectedPriceId, setSelectedPriceId] = useState();
  const [showCancelSubsConfirmation, setShowCancelSubsConfirmation] = useState();
  const [cancelSubsPayload, setCancelSubsPayload] = useState();
  const [showCancelCta, setShowCancelCta] = useState(true);
  const [autoRenewal, setAutoRenewal] = useState(true);
  const [activeProductAndPlans, setActiveProductAndPlans] = useState([]);
  const [updatingSubsAutoRenewal, setUpdatingSubsAutoRenewal] = useState(false);
  const [activeProduct, setActiveproduct] = useState("covid");

  const handleLogout = () => {
    axios
      .get(config.backend_url + "/logout")
      .then(function (response) {
        history.push("/login");
        dispatch(action.logoutUser());
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  const createSubscription = async (_planPrice, product, isOneTime, productType) => {
    const stripeCustomerId = stripeCustomer?.customerId;
    const priceId = _planPrice;
    const _uid = user.uid;

    if (!stripeCustomerId || !priceId) {
      // return alert("stripeCustomerId or priceId missing");
    }

    const createStripeSubscriptionResp = await createStripeSubscription({
      stripeCustomerId,
      priceId,
      product,
      uid: _uid,
      coupon: product?.coupon?.stripe?.id,
      collectionMethod: isOneTime ? "send_invoice" : autoRenewal ? "charge_automatically" : "send_invoice", // charge_automatically (Default) | send_invoice
      // TODO FIX
    });
    setClientSecret(createStripeSubscriptionResp?.clientSecret);
    setSubscription(createStripeSubscriptionResp?.subscription);
    dispatch(action.updateSubscription({...subscriptionFromRedux, ...createStripeSubscriptionResp?.subscription}));

    if (productType === 'covid') {
      setCovidClientSecret(createStripeSubscriptionResp?.clientSecret)
      setCovidSubscription(createStripeSubscriptionResp?.subscription)
    } else if (productType === 'cardio') {
      setCardioClientSecret(createStripeSubscriptionResp?.clientSecret)
      setCardioSubscription(createStripeSubscriptionResp?.subscription)
    }

    setTimeout(() => {
      window.scrollTo({top: document.body.scrollHeight, behavior: "smooth"});
    }, 750);
  };

  const updateSubscription = async (_planPrice, isOneTime, productForUpdateSubs) => {
    if (productForUpdateSubs?.productType === "covid") {
      const stripeCustomerId = stripeCustomer?.customerId;
      const priceId = _planPrice || planPrice;
      const _uid = user.uid;

      if (!stripeCustomerId || !priceId || !_uid) {
        return console.log("stripeCustomerId or priceId or uid is missing");
      }
      const updateStripeSubscriptionResp = await updateStripeSubscription({
        stripeCustomerId,
        priceId,
        uid: _uid,
        coupon: productForUpdateSubs?.coupon?.stripe?.id,
        collectionMethod: productForUpdateSubs?.isOneTime ? "send_invoice" : autoRenewal ? "charge_automatically" : "send_invoice", // charge_automatically (Default) | send_invoice
        productType: productForUpdateSubs?.productType,
        subscriptionId: covidSubscription?._id
      });
      setClientSecret(updateStripeSubscriptionResp?.clientSecret);
      // Reset the client secret first.
      setCovidClientSecret()
      setCovidClientSecret(updateStripeSubscriptionResp?.clientSecret)
      setSubscription(updateStripeSubscriptionResp?.subscription);
      setCovidSubscription(updateStripeSubscriptionResp?.subscription);
      dispatch(action.updateSubscription({...subscriptionFromRedux, ...updateStripeSubscriptionResp?.subscription}));
      setShowConfirm(false);
      setTimeout(() => {
        window.scrollTo({top: document.body.scrollHeight, behavior: "smooth"});
      }, 750);
    } else if (productForUpdateSubs?.productType === "cardio") {
      const stripeCustomerId = stripeCustomer?.customerId;
      const priceId = _planPrice || planPrice;
      const _uid = user.uid;

      if (!stripeCustomerId || !priceId || !_uid) {
        return console.log("stripeCustomerId or priceId or uid is missing");
      }
      const updateStripeSubscriptionResp = await updateStripeSubscription({
        stripeCustomerId,
        priceId,
        uid: _uid,
        coupon: productForUpdateSubs?.coupon?.stripe?.id,
        collectionMethod: productForUpdateSubs?.isOneTime ? "send_invoice" : "charge_automatically", // charge_automatically (Default) | send_invoice
        productType: productForUpdateSubs?.productType,
        subscriptionId: cardioSubscription?._id
      });
      setClientSecret(updateStripeSubscriptionResp?.clientSecret);
      // Reset the client secret first.
      setCardioClientSecret();
      setCardioClientSecret(updateStripeSubscriptionResp?.clientSecret);
      setSubscription(updateStripeSubscriptionResp?.subscription);
      setCardioSubscription(updateStripeSubscriptionResp?.subscription);
      dispatch(action.updateSubscription({...subscriptionFromRedux, ...updateStripeSubscriptionResp?.subscription}));
      setShowConfirm(false);
      setTimeout(() => {
        window.scrollTo({top: document.body.scrollHeight, behavior: "smooth"});
      }, 750);
    }
  };

  const checkStatus = async () => {
    const userStatus = await getUserStatus({
      uid: user.uid,
      accountType: user.accountType,
      affiliateLinkId: user.affiliateLinkId,
      weekFrom,
      weekTo,
      monthFrom,
      monthTo,
    });

    const totalTestByPeriod = userStatus.totalTestByPeriod;
    const testLimitByPlan = userStatus.testLimitByPlan;
    dispatch(
      action.updateSubscription({
        ...userStatus?.subscription,
        testLimitByPlan,
        totalTestByPeriod,
        totalTestRemaining: testLimitByPlan - totalTestByPeriod,
      })
    );
    dispatch(
      action.updateSubscriptions({
        data: userStatus?.subscriptions,
        testLimitByPlan,
        totalTestByPeriod,
        totalTestRemaining: testLimitByPlan - totalTestByPeriod,
      })
    );
  };

  useEffect(() => {
    // Check if user is from free account
    if (user.accountType === "free") history.push("/home");

    // Check if Stripe customer exist | if not create one
    getCustomerByUid(user.uid).then(async (res) => {
      // Get the stripe customer object
      if (res.customer) {
        setStripeCustomer(res.customer);
      } else {
        // Create customer in stripe and save it to database.
        const email = user.email;
        const fullName = user.firstName + " " + user.lastName;
        const country = user?.address?.country;
        const state = user?.address?.stateProvince;
        const stripeCustomerResp = await createStripeCustomer({email, fullName, country, state, uid: user.uid});
        setStripeCustomer(stripeCustomerResp.customer);
      }

      // All products
      const productsResp = await getProductsAndPrices(user?.affiliateLinkId || "");

      setAffiliateAccount(productsResp?.affiliateAccount);

      // Sort and expand product by each pricing
      const productEachPrice = [];

      for (const product of productsResp.products) {
        product.prices.forEach((price) => {
          if (user.cardio_access && product.productType === "cardio") {
            productEachPrice.push({ ...product, price });
          } else if (user?.covid_access && product.productType === "covid") {
            productEachPrice.push({ ...product, price });
          }
        });
      }

      setProducts(productEachPrice);
      _.sortBy(productEachPrice, (product) => product?.price.recurring.interval_count).every((product) => {
				if (product?.price.recurring.interval === 'month') {
					if (product?.price.recurring.interval_count === 6) {
						setPlanDurationInterval(6);
						return false;
					}
					if (product?.price.recurring.interval_count === 3) {
						setPlanDurationInterval(3);
						return false;
					}
					if (product?.price.recurring.interval_count === 1) {
						setPlanDurationInterval(1);
						return false;
					}
				}
				return true;
			});
      
      // Retrieve and set the subscription | if not provide option to create subscription for list of products.
      const subscriptionResp = await getSubscriptionByUid(user.uid);
      const subscriptionsResp = await getSubscriptionsByUid(user.uid);
      console.log("subscriptionsResp::", subscriptionsResp)
      setSubscriptions(subscriptionsResp?.subscriptions)

      const covidSub = subscriptionsResp?.subscriptions.filter(
        (sub) => sub.productType === "covid" && (sub.status === "incomplete" || sub.status === "active")
      )[0];
      const cardioSub = subscriptionsResp?.subscriptions.filter(
        (sub) => sub.productType === "cardio" && (sub.status === "incomplete" || sub.status === "active")
      )[0];
      const pendingCancelCovidSub = subscriptionsResp?.subscriptions.filter(
        (sub) => sub.productType === "covid" && sub.status === "pending_cancel"
      )[0];
      const pendingCancelCardioSub = subscriptionsResp?.subscriptions.filter(
        (sub) => sub.productType === "cardio" && sub.status === "pending_cancel"
      )[0];

      console.log("covidSub::", covidSub)
      console.log("cardioSub::", cardioSub)
      console.log("pendingCancelCovidSub::", pendingCancelCovidSub)
      console.log("pendingCancelCardioSub::", pendingCancelCardioSub)

      setCovidSubscription(pendingCancelCovidSub || covidSub)
      setCovidClientSecret(covidSub?.clientSecret)

      setCardioSubscription(pendingCancelCardioSub || cardioSub)
      setCardioClientSecret(cardioSub?.clientSecret)

      if (!subscriptionResp.subscription) {
        console.log("No subscription:: creating new one...");
        // Create new subscription
        setIsloading(false);
        return;
      }

      setSubscription(subscriptionResp.subscription);

      if (!subscriptionFromRedux?.testLimitByPlan) {
        await checkStatus();
      } else {
        dispatch(action.updateSubscription({...subscriptionFromRedux, ...subscriptionResp?.subscription}));
      }
      setClientSecret(subscriptionResp.subscription?.clientSecret);
      setSubscribedPlan(subscriptionResp.subscription?.stripe?.plan?.id);

      // Get Price Plan object
      const pricePlanResp = await getPricePlan(subscriptionResp.subscription?.stripe?.plan?.id);
      setCurrentPricePlan(pricePlanResp.plans);

      // Get product detail
      const productId = subscriptionResp?.subscription?.stripe?.plan?.product;
      const productResp = await getStripeProduct(productId);
      setCurrentProduct(productResp.product);

      // Get Pirce Plan and product detail for multi subscriptions

      const activeProducts = subscriptionsResp?.subscriptions
        .filter((sub) => sub?.stripe?.status === "active" && (sub.status === "active" || sub.status === "pending_cancel"))
        .map((sub) => {
          return {
            productId: sub?.stripe?.plan?.product,
            planId: sub?.stripe?.plan?.id,
            currentPeriodStart: sub?.stripe?.current_period_start,
            currentPeriodEnd: sub?.stripe?.current_period_end,
          };
        });

      const _activeProductAndPlans = [];

      for await(const {productId, planId, currentPeriodStart, currentPeriodEnd} of activeProducts) {
        const _productResp = await getStripeProduct(productId);
        const _pricePlanResp = await getPricePlan(planId);

        _activeProductAndPlans.push({
          product: _productResp?.product,
          pricePlan: _pricePlanResp?.plans,
          currentPeriodStart: moment
            .unix(currentPeriodStart)
            .tz(user?.timezone || "Etc/UTC")
            .format("Do MMM YYYY, h:mm:ss A"),
          currentPeriodEnd: moment
            .unix(currentPeriodEnd)
            .tz(user?.timezone || "Etc/UTC")
            .format("Do MMM YYYY, h:mm:ss A"),
        });
      }

      setActiveProductAndPlans(_activeProductAndPlans)

      // Get all transactions
      const transactions = getAllStripeTransactions();

      // Get latest invoice status from subscription

      // Display UI
      setIsloading(false);

      // Set the autoRenewal logic
      if (!covidSub && !cardioSub) {
        return setAutoRenewal(true)
      }

      if (covidSub?.stripe?.collection_method === 'charge_automatically' || cardioSub?.stripe?.collection_method === 'charge_automatically') {
        setAutoRenewal(true)
      } else {
        setAutoRenewal(false)
      }
    });
  }, []);

  const options = {
    // passing the client secret obtained from the server
    clientSecret: clientSecret,
  };

  const fullRedirectToHome = () => {
    window.location.replace("/home");
  };
  const fullReload = () => {
    window.location.reload();
  };
  const oneTimeProduct = _.isEmpty(products) ? {} : products.filter((product) => product.isOneTime)[0];

  const onSubscribeHandle = async (stripeCustomerId, priceId, uid, product, isOneTime, testCounts) => {
    if (product?.productType === 'covid') {
      setSelectedPriceId(priceId);
      if (covidSubscription) {
        setPlanPrice(priceId);
        setProductForUpdateSubs(product);
      }

      // Check if they resubscribing to same plan for onetime
      if (priceId === covidSubscription?.stripe?.plan?.id && isOneTime && testCounts?.totalTestRemaining > 0) {
        setShowOneTimeProductWarning(true);
        // setIsForceDisabled(false)
        return;
      }
      // Check if they resubscribing to same plan for non onetime
      if (priceId === covidSubscription?.stripe?.plan?.id && testCounts?.totalTestRemaining > 0) {
        setShowMonthlyProductRenewWarning(true);
        return;
      }

      // Find if it's downgrade or upgrade

      // Check Product level downgrade..
      // Get standard price for current product
      const currentProductId = covidSubscription?.stripe?.plan?.product;
      if (currentProductId && user.accountType !== "canceled") {
        const currentProductResp = await getStripeProduct(currentProductId);

        const newPricePlan = await getPricePlan(priceId);
        const newProductResp = await getStripeProduct(newPricePlan.plans.product);
        if (
          parseInt(newProductResp?.product?.metadata?.default_amount) <
          parseInt(currentProductResp?.product?.metadata?.default_amount)
        ) {
          return setShowInfo(true);
        }
      }

      // Check if its' updating the existing covidSubscription.
      console.log("covidSubscription::", covidSubscription)

      if (covidSubscription) {
        setPlanPrice(priceId);
        setProductForUpdateSubs(product);
        console.log("setShowConfirm::", showConfirm)
        return setShowConfirm(true);
      }
      setPlanPrice(priceId);
      await createSubscription(priceId, product, isOneTime, product?.productType);
    } else if (product?.productType === 'cardio') {

      // Canceling handler if the same covid product and is cancelled.
      if (priceId === cardioSubscription?.stripe?.plan?.id && !cardioSubscription?.stripe?.cancel_at_period_end) {
        return;
      }
      setSelectedPriceId(priceId);
      if (cardioSubscription) {
        setPlanPrice(priceId);
        setProductForUpdateSubs(product);
      }

      // Check if they resubscribing to same plan for onetime
      // if (priceId === cardioSubscription?.stripe?.plan?.id && isOneTime && testCounts?.totalTestRemaining > 0) {
      //   setShowOneTimeProductWarning(true);
      //   // setIsForceDisabled(false)
      //   return;
      // }
      // Check if they resubscribing to same plan for non onetime
      if (priceId === cardioSubscription?.stripe?.plan?.id) {
        setShowMonthlyProductRenewWarningCovid(true);
        return;
      }

      // Find if it's downgrade or upgrade

      // Check Product level downgrade..
      // Get standard price for current product
      const currentProductId = cardioSubscription?.stripe?.plan?.product;
      if (currentProductId && user.accountType !== "canceled") {
        const currentProductResp = await getStripeProduct(currentProductId);

        const newPricePlan = await getPricePlan(priceId);
        const newProductResp = await getStripeProduct(newPricePlan.plans.product);
        if (
          parseInt(newProductResp?.product?.metadata?.default_amount) <
          parseInt(currentProductResp?.product?.metadata?.default_amount)
        ) {
          return setShowInfo(true);
        }
      }

      // Check if its' updating the existing cardioSubscription.
      if (cardioSubscription) {
        setPlanPrice(priceId);
        setProductForUpdateSubs(product);
        return setShowConfirm(true);
      }
      setPlanPrice(priceId);
      await createSubscription(priceId, product, isOneTime, product?.productType);
    }
  };

  const onCancelSubscribe = async (subscription) => {
    setCancelSubsPayload({subscription});
    setShowCancelSubsConfirmation(true);
  };
  const onCancelSubscribeHandle = async (payload, productType) => {
    const updatedSubscription = await cancelSubscription({
      uid: user.uid,
      subscription: cancelSubsPayload?.subscription,
    });
    dispatch(action.updateSubscription({...subscriptionFromRedux, ...updatedSubscription?.subscription}));
    setShowCancelCta(false);


    const _subscriptionsFromRedux = [];
    const _covidSubsFromRedux = subscriptionsFromRedux?.data?.filter(sub => sub.productType === 'covid')
    const _cardioSubsFromRedux = subscriptionsFromRedux?.data?.filter(sub => sub.productType === 'cardio')

    if (productType === "covid") {
      setCovidSubscription(updatedSubscription?.subscription);
      _subscriptionsFromRedux.push(_cardioSubsFromRedux);
      _subscriptionsFromRedux.push(updatedSubscription?.subscription);
    } else if (productType === "cardio") {
      setCardioSubscription(updatedSubscription?.subscription);
      _subscriptionsFromRedux.push(_covidSubsFromRedux);
      _subscriptionsFromRedux.push(updatedSubscription?.subscription);
    }

    dispatch(action.updateSubscriptions({...subscriptionsFromRedux, data: _subscriptionsFromRedux}))

    // fullReload();
    notifySuccess("Your current plan has been canceled.");
  };

  const autoRenewUpdateHandle = async (isOn) => {
    setUpdatingSubsAutoRenewal(true);
    if (isOn) {
      const updateSubscriptionAutoRenewResp = await updateSubscriptionAutoRenew({
        uid: user?.uid,
        collectionMethod: "charge_automatically",
      });
      if (updateSubscriptionAutoRenewResp?.success) {
        setAutoRenewal(isOn);
        notifySuccess("Auto renewal is enabled");
      } else {
        notifyError("Something went wrong");
      }
      setUpdatingSubsAutoRenewal(false);
    } else if (!isOn) {
      const updateSubscriptionAutoRenewResp = await updateSubscriptionAutoRenew({
        uid: user?.uid,
        collectionMethod: "send_invoice",
      });
      if (updateSubscriptionAutoRenewResp?.success) {
        setAutoRenewal(isOn);
        notifySuccess("Auto renewal is disabled");
      } else {
        notifyError("Something went wrong");
      }
      setUpdatingSubsAutoRenewal(false);
    }
  }

  const hasMonthDurationPlan = (monthInterval) => {
		const _products = products
			.filter((product) => product.price.recurring.interval === 'month')
			.filter((product) => product.price.recurring.interval_count === monthInterval);
		if (_products.length > 0) {
			return true;
		}
		return false;
	};

  if(user?.hasRevenueCatSub) {
    return (
      <div className="container">
        <div className="main navigation" data-testid="navigation">
          <div className="header mt-3">
            <img src={Home} alt="home" onClick={() => history.push("/home")}></img>
            <img
              src={user?.picture ? user.picture : Profile}
              alt="profile"
              className="profile mt-4"
              onClick={() => history.push("/navigation")}
            ></img>
            <img src={Logout} alt="logout" onClick={handleLogout}></img>
          </div>
          <p className="text-center mt-3 heading">Account</p>
          <p>Please go to Mobile app for plans</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="main navigation" data-testid="navigation">
        <div className="header mt-3">
          <img src={Home} alt="home" onClick={() => history.push("/home")}></img>
          <img
            src={user?.picture ? user.picture : Profile}
            alt="profile"
            className="profile mt-4"
            onClick={() => history.push("/navigation")}
          ></img>
          <img src={Logout} alt="logout" onClick={handleLogout}></img>
        </div>
        <p className="text-center mt-3 heading">Account</p>
        {isLoading && <div id="cover-spin"></div>}
        {(paymentSuccess) ? (
          <div className="wrapper" data-testid="wrapper">
            <div className="checkmark-container">
              <i className="checkmark">✓</i>
            </div>
            <div className="success-title">Payment Successful</div>
            <div>Your payment was successful.</div>
            <div>You can continue using iSelfie.</div>
            <button className="success-home" onClick={fullRedirectToHome}>
              Go to Home
            </button>
          </div>
        ) : (
          <div className="wrapper" data-testid="wrapper">
            {!_.isEmpty(activeProductAndPlans) && <div className="active-plan">Active Plan</div>}
            <br/>
            {(covidSubscription?.stripe?.status === "active" || cardioSubscription?.stripe?.status === "active") && (
              <div className="toggle-container">
                <div className="auto-renew">Auto Renewal:</div>
                <div className="switch-auto-renew">
                  <Switch data-testid="switch-auto-renew-covid" checked={autoRenewal} onChange={autoRenewUpdateHandle}
                          loading={updatingSubsAutoRenewal}/>
                </div>
              </div>
            )}
            {!_.isEmpty(activeProductAndPlans) && (
              <div className="active-sub-wrapper">
                {activeProductAndPlans.map((activeProductAndPlan) => {
                  return <ActiveSubscription key={activeProductAndPlan.product._id} activeProductAndPlan={activeProductAndPlan}/>;
                })}
              </div>
            )}
            <div className="product-type-container">
              <button
                className={`product-type-button ${activeProduct === "covid" ? "product-type-button-active" : ""}`}
                data-testid="covid-product-type-button"
                onClick={() => {
                  setActiveproduct("covid");
                  setClientSecret(covidSubscription?.clientSecret);
                }}
              >
                Covid
              </button>
              {((affiliateAccount && affiliateAccount?.cardio) || (!affiliateAccount && user.cardio_access)) && (
                <button
                  className={`product-type-button ${activeProduct === "cardio" ? "product-type-button-active" : ""}`}
                  data-testid="cardio-product-type-button"
                  onClick={() => {
                    setActiveproduct("cardio");
                    setClientSecret(cardioSubscription?.clientSecret);
                  }}
                >
                  Cardio
                </button>
              )}
            </div>
            {!affiliateAccount && (
              <>
                <div className="toggle-wrapper">
                  {hasMonthDurationPlan(1) && <button
                    className={`month-button ${planDurationInterval !== 1 && "inactive-duration"}`}
                    data-testid="3-month-button"
                    onClick={() => setPlanDurationInterval(1)}
                  >
                    1 Month
                  </button>}
                  
                  {hasMonthDurationPlan(3) && <button
                    className={`month-button ${planDurationInterval !== 3 && "inactive-duration"}`}
                    data-testid="3-month-button"
                    onClick={() => setPlanDurationInterval(3)}
                  >
                    3 Months
                  </button>}
                  
                  {hasMonthDurationPlan(6) && <button
                    className={`month-button ${planDurationInterval !== 6 && "inactive-duration"}`}
                    data-testid="6-month-button"
                    onClick={() => setPlanDurationInterval(6)}
                  >
                    6 Months
                  </button>}
                  
                </div>
                <div className="product-list">
                  {
                    !_.isEmpty(oneTimeProduct) &&
                    activeProduct === "covid" &&
                    !(covidSubscription?.stripe?.status === "active") && (
                      <Product
                        selectedPriceId={selectedPriceId}
                        testCounts={{
                          totalTestByPeriod: subscriptionFromRedux.totalTestByPeriod,
                          testLimitByPlan: subscriptionFromRedux.testLimitByPlan,
                          totalTestRemaining: subscriptionFromRedux.totalTestRemaining,
                        }}
                        product={oneTimeProduct}
                        productName={oneTimeProduct.name}
                        productDescription={oneTimeProduct?.description}
                        onSubscribe={onSubscribeHandle}
                        subscribeCtaText="Select"
                        disableSubscribe={false}
                        amount={oneTimeProduct?.price?.amount}
                        features={oneTimeProduct?.features || []}
                        stripeCustomerId={stripeCustomer?.customerId}
                        priceId={oneTimeProduct?.price?.stripePriceId}
                        uid={user.uid}
                        subscription={activeProduct === "covid" ? covidSubscription : cardioSubscription}
                        intervalCount={oneTimeProduct?.price?.recurring?.interval_count}
                        onCancelSubscribe={onCancelSubscribe}
                        showCancelCta={showCancelCta}
                        activeProduct={activeProduct}
                        isAutoRenewal={autoRenewal}
                      />
                    )}
                  {products
                    .filter((product) => product.price?.recurring?.interval === 'month')
                    .filter((product) => product.price.recurring.interval_count === planDurationInterval && product.productType === activeProduct)
                    .sort((pre, post) => (pre?.price?.amount > post?.price?.amount ? 1 : -1))
                    .map((product) => {
                      const activeSubscription = activeProduct === "covid" ? covidSubscription : cardioSubscription;
                      return (
                        <Product
                          key={product._id}
                          selectedPriceId={selectedPriceId}
                          testCounts={{
                            totalTestByPeriod: subscriptionFromRedux.totalTestByPeriod,
                            testLimitByPlan: subscriptionFromRedux.testLimitByPlan,
                            totalTestRemaining: subscriptionFromRedux.totalTestRemaining,
                          }}
                          coupon={product?.coupon}
                          product={product}
                          productName={product.name}
                          productDescription={product?.description}
                          onSubscribe={onSubscribeHandle}
                          subscribeCtaText="Select"
                          disableSubscribe={false}
                          amount={product?.price?.amount}
                          features={product?.features || []}
                          stripeCustomerId={stripeCustomer?.customerId}
                          priceId={product?.price?.stripePriceId}
                          uid={user.uid}
                          subscription={activeSubscription}
                          intervalCount={product.price.recurring.interval_count}
                          onCancelSubscribe={onCancelSubscribe}
                          showCancelCta={showCancelCta}
                          showCTA={
                            activeProduct === "cardio" &&
                            product?.price?.stripePriceId === activeSubscription?.stripe?.plan?.id
                          }
                          activeProduct={activeProduct}
                          isAutoRenewal={autoRenewal}
                        />
                      );
                    })}
                </div>
              </>
            )}
            {affiliateAccount?.planTemplate === "single-monthly" && (
              <div className="product-list">
                {products
                  .filter((product) => product.productType === activeProduct)
                  // Hide One time product when active covid subscription is present.
                  .filter((product) => {
                    if (
                      (covidSubscription?.status === "active" || covidSubscription?.status === "pending_cancel") &&
                      product?.isOneTime
                    ) {
                      return false;
                    }
                    return true;
                  })
                  .sort((pre, post) => (pre?.price?.amount > post?.price?.amount ? 1 : -1))
                  .map((product) => {
                    const activeSubscription = activeProduct === "covid" ? covidSubscription : cardioSubscription;
                    return (
                      <Product
                        key={product._id}
                        selectedPriceId={selectedPriceId}
                        testCounts={{
                          totalTestByPeriod: subscriptionFromRedux.totalTestByPeriod,
                          testLimitByPlan: subscriptionFromRedux.testLimitByPlan,
                          totalTestRemaining: subscriptionFromRedux.totalTestRemaining,
                        }}
                        coupon={product?.coupon}
                        product={product}
                        productName={product.name}
                        productDescription={product?.description}
                        onSubscribe={onSubscribeHandle}
                        subscribeCtaText="Select"
                        disableSubscribe={false}
                        amount={product?.price?.amount}
                        features={product?.features || []}
                        stripeCustomerId={stripeCustomer?.customerId}
                        priceId={product?.price?.stripePriceId}
                        uid={user.uid}
                        subscription={activeSubscription}
                        intervalCount={product.price.recurring.interval_count}
                        onCancelSubscribe={onCancelSubscribe}
                        showCancelCta={showCancelCta}
                        showCTA={
                          activeProduct === "cardio" &&
                          product?.price?.stripePriceId === activeSubscription?.stripe?.plan?.id
                        }
                        activeProduct={activeProduct}
                        isAutoRenewal={autoRenewal}
                      />
                    );
                  })}
              </div>
            )}
            {covidClientSecret &&
              activeProduct === "covid" &&
              covidSubscription?.stripe?.status !== "active" &&
              covidSubscription?.stripe?.status !== "past_due" && (
                <div className="stripe-container" id="stripe-container">
                  <Elements stripe={stripePromise} options={{clientSecret: covidClientSecret}}>
                    <CheckoutForm setPaymentSuccess={setPaymentSuccess}/>
                  </Elements>
                </div>
              )}
            {cardioClientSecret &&
              activeProduct === "cardio" &&
              cardioSubscription?.stripe?.status !== "active" &&
              cardioSubscription?.stripe?.status !== "past_due" && (
                <div className="stripe-container" id="stripe-container">
                  <Elements stripe={stripePromise} options={{clientSecret: cardioClientSecret}}>
                    <CheckoutForm setPaymentSuccess={setPaymentSuccess}/>
                  </Elements>
                </div>
              )}
            <ConfirmModal
              show={showConfirm}
              onContinue={() => updateSubscription(null, null, productForUpdateSubs)}
              onClose={() => {
                setSelectedPriceId();
                setShowConfirm(false);
              }}
              title="Confirmation"
              message={
                productForUpdateSubs?.isOneTime
                  ? "Do you want to continue with this purchase?"
                  : "Do you want to change the subscription plan?"
              }
            />
            <InfoModal
              show={showInfo}
              onClose={() => {
                setSelectedPriceId();
                setShowInfo(false);
              }}
              title="Alert"
              message="You cannot downgrade at the moment and have to wait until your current subscription ends."
            />
            <InfoModal
              show={showOneTimeProductWarning}
              onClose={() => setShowOneTimeProductWarning(false)}
              title="Warning"
              message="You have yet to utilize the COVID-19 test you acquired earlier. Kindly utilize it before considering the purchase of another one."
            />
            <InfoModal
              show={showMonthlyProductRenewWarning}
              onClose={() => {
                setShowMonthlyProductRenewWarning(false);
                setSelectedPriceId();
              }}
              title="Warning"
              onContinue={() => {
                setShowMonthlyProductRenewWarning(false);
                updateSubscription(null, null, productForUpdateSubs);
              }}
              message="Purchasing a new subscription before the current one expires will reset the COVID-19 test allocation and billing cycle. Any remaining unused COVID-19 tests will be forfeited. Are you sure you want to proceed?"
            />
            <InfoModal
              show={showMonthlyProductRenewWarningCovid}
              onClose={() => {
                setShowMonthlyProductRenewWarningCovid(false);
                setSelectedPriceId();
              }}
              title="Warning"
              onContinue={() => {
                setShowMonthlyProductRenewWarningCovid(false);
                updateSubscription(null, null, productForUpdateSubs);
              }}
              message="Do you want to re-subscribe to this plan?"
            />
            <InfoModal
              show={showCancelSubsConfirmation}
              onClose={() => {
                setShowCancelSubsConfirmation(false);
                setCancelSubsPayload();
              }}
              title="Cancel Subscription"
              onContinue={() => {
                setShowCancelSubsConfirmation(false);
                onCancelSubscribeHandle(cancelSubsPayload, activeProduct);
              }}
              message="Are you looking to cancel your subscription? Please be aware that your subscription will remain active until its expiration date but will not renew once it has expired."
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default Plans;
